<template>
  <div class="w-100" >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="ml-2 mt-2 pr-3 estiloCards" :style="{ 'max-height': !navegandoMovil ? (maxheight - 150) + 'px' : '' }">
      <b-row cols="1" cols-md="3" cols-lg="4" cols-xl="5" class="d-flex align-items-center">
        <template v-for="(archivo, index) in listArchivos">
          <b-col class="mb-3" :key="'archivo-'+index" @click="mostrarHerramienta(archivo, index)" style="cursor: pointer">
            <img alt="herramientas" v-if="archivo.extension === 'png' ||
                        archivo.extension === 'jpeg' ||
                        archivo.extension === 'jpg'  &&
                    archivo.imagenBase64 !== undefined &&
                    archivo.imagenBase64 !== null &&
                    archivo.imagenBase64 !== ''" class="tamanioImg tamanioImg-lg"
                 :src="'data:image/jpeg;base64,'+archivo.imagenBase64"
                 />
            <div v-if="
                  archivo.extension === 'pdf' &&
                  archivo.imagenBase64 !== undefined &&
                  archivo.imagenBase64 !== null &&
                  archivo.imagenBase64 !== ''
                ">
              <pdf
                  v-for="i in 1"
                  :key="i"
                  :page="i"
                  :src="'data:application/pdf;base64,'+archivo.imagenBase64"
              ></pdf>
            </div>

            <div v-if="archivo.extension !== 'png' &&
                  archivo.extension !== 'jpg'  &&
                  archivo.extension !== 'jpeg'  &&
                  archivo.extension !== 'pdf'  ||
                  archivo.imagenBase64 === undefined ||
                  archivo.imagenBase64 === null ||
                  archivo.imagenBase64 === ''"
                 >
              <img alt="herramientas" style="object-fit: cover; width: 100%; height: 100%;" src="../../../assets/logoColor.png"/>
              <span style="font-size: small;" class="bold">No hay vista previa</span>
            </div>


            <p style="font-size: small; overflow-wrap: break-word;"
               class="m-0"
              v-if="archivo.Name !== undefined &&
                    archivo.Name !== null">
              {{ archivo.Name }}
            </p>

          </b-col>
        </template>
      </b-row>
    </div>
    <vista-previa-herramienta :modalVisor="modalVisorImg" :archivo="archivoSeleccionado" :listaVisor="listaVisor"    @modalVisor="modalVisorImg = $event" ></vista-previa-herramienta>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import VistaPreviaHerramienta from "@/version5/herramientas/componentes/VistaPreviaHerramienta";
export default {
  name: "cardsHerramientas",
  components: {
    VistaPreviaHerramienta,
    pdf,
  },
  props: {
    listArchivos: Array,
    listaVisor:Array,
    maxheight:Number,
    navegandoMovil:Boolean
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      modalVisorImg:false,
      archivoSeleccionado: null,
      indexSeleccionado: 0
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    mostrarHerramienta(herramienta, index) {
      this.modalVisorImg = true;
      this.archivoSeleccionado = null;
      this.archivoSeleccionado = herramienta;
      this.indexSeleccionado = index;
    }
  }
}
</script>

<style scoped>
.estiloCards {
  width:100%;
  overflow-y: auto;
}
</style>
